import * as React from 'react';

import {BannerCueCards} from '../../../glossary/layout/banner-cue-cards';
import {RouteContext} from '../../../route-context';

import {useGetFacebookIntegration} from '../graphql/hooks/use-get-facebook-integration';

import {SettingsIntegrationComplete} from './settings-integration-complete';
import {SettingsNoIntegration} from './settings-no-integration';

export function Settings() {
    const {
        facebookIntegration,
        isLoading: isLoadingFacebookIntegration,
        refetch: refetchFacebookIntegration,
        startPolling,
        stopPolling,
    } = useGetFacebookIntegration();

    const isEmbedded = React.useContext(RouteContext).isEmbedded;

    // Control polling based on integration status
    // This is mainly done for rcfx embed because they are redirected
    // to a new tab so we gotta make sure we're polling the current tab
    // to update the integration status
    React.useEffect(() => {
        if (isEmbedded && (!facebookIntegration || !facebookIntegration.hasAuthToken)) {
            startPolling(5000); // Start polling every 5 seconds
        } else {
            stopPolling(); // Stop polling when enabled
        }

        return () => stopPolling();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [facebookIntegration, isEmbedded]);

    const [errorMessage, setErrorMessage] = React.useState('');
    React.useEffect(() => {
        const url = new URL(window.location.href);
        const error = url.searchParams.get('errorMessage');

        if (!error) {
            return;
        }

        url.searchParams.delete('errorMessage');
        // @ts-expect-error
        window.history.replaceState(null, null, url);
        setErrorMessage(`Authentication failed: ${error}`);
    }, []);

    if (isLoadingFacebookIntegration && !facebookIntegration) {
        return null;
    }

    return (
        <div className='px-16 py-24 full-width overflow-auto'>
            <BannerCueCards />
            {facebookIntegration && facebookIntegration.hasAuthToken ? (
                <SettingsIntegrationComplete
                    facebookIntegration={facebookIntegration}
                    isLoadingFacebookIntegration={isLoadingFacebookIntegration}
                    refetchFacebookIntegration={refetchFacebookIntegration}
                />
            ) : (
                <SettingsNoIntegration errorMessage={errorMessage} />
            )}
        </div>
    );
}
